import React, { useRef, useState } from 'react'
import SearchBar from '../../../components/SearchBar/SearchBar'
import Button from '../../../components/Button/Button'
import Eventcard from '../../../components/Eventcard/Eventcard'
import Paginationarrow from '../../../components/Paginationarrow/Paginationarrow'
import { useNavigate } from 'react-router'
import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { adminData, clearEvents, clearState, getAllEvents } from '../../../reducer/adminSlice'
import DatanotFound from '../../../components/DatanotFound/DatanotFound'
import PageLoader from '../../../components/loaders/PageLoader/PageLoader'
import moment from 'moment'
import ErrorToast from '../../../components/Toast/ErrorToast'
import Skeleton from 'react-loading-skeleton'

const Events = () => {

    //Search states
    const [search, setSearch] = useState("");

    //Load more states
    const [index, setIndex] = useState(1);
    const [totalEvents, setTotalEvents] = useState([]);

    //Toast states
    const [isShowError, setIsShowError] = useState(false);
    const [errMessage, setErrMessage] = useState("");
    
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const { isEventsFetching, isSuccess, isError, errorMessage, events } = useSelector(adminData);

    //Search functions
    const handleSearchChange = (e) => {
        const { value } = e.target;
        setSearch(value);
    };

    const handleSearch = (e) => {
        if(e.key === "Enter") {
            setTotalEvents([]);
            setIndex(1);
            dispatch(getAllEvents({search}));
        }
    };

    const handleSearchPress = (e) => {
        if(e.key === "Enter") {
            setTotalEvents([]);
            setIndex(1);
            dispatch(getAllEvents({search}));
        }
    };

    //Load more functions
    const handleLoadMore = () => {
        setIndex(prev => prev + 1);
        dispatch(getAllEvents({index: index + 1}));
    };

    useEffect(() => {
        dispatch(getAllEvents({}));

        return () => {
            dispatch(clearEvents());
        }
    },[]);

    useEffect(() => {
        if(index === 1 && events?.events?.length > 0) setTotalEvents(events?.events);
        if(index !== 1 && events?.events?.length > 0) setTotalEvents(prev => [...prev, ...events?.events]);
    },[events?.events]);

    useEffect(() => {
        if(isError) {
            setIsShowError(true);
            setErrMessage(errorMessage);
            dispatch(clearState());
        }
    },[isError]);

    const targetRef = useRef(null);

    useEffect(() => {

        const element = document.querySelector(".mainWrapper");

        const handleScroll = () => {
            console.log("SCroll")
          if (targetRef.current) {
            const { top } = targetRef.current.getBoundingClientRect();
            const windowHeight = window.innerHeight || document.documentElement.clientHeight;
    
            if (top <= windowHeight) {
              handleLoadMore();
            }
          }
        };
    
        element.addEventListener('scroll', handleScroll);
    
        return () => {
          element.removeEventListener('scroll', handleScroll);
        };
      }, [handleLoadMore]);

    return (
        <>
        {/* {isEventsFetching && <PageLoader />} */}
        <ErrorToast
        show={isShowError}
        setShow={() => setIsShowError(false)}
        message={errMessage}
      />
        <div className='AdEventMainCardwrap'>
            <div>
                <h2 className='heading-2 mb6'>Events</h2>
                {isEventsFetching ? <Skeleton width={"80px"} /> : <p className='text3'>Total {events?.totalCount ?? 0}</p>}
            </div>

            <div className="Allcardboxwrapper mt-20">
                <div className="FaqUserFiltter flex-between">
                    {isEventsFetching ? <Skeleton width={"280px"} height={"30px"} /> : <SearchBar placeholder={'Search here...'} className={'searchbardesign'} value={search} onChange={handleSearchChange} onClick={handleSearch} onKeyDown={handleSearchPress} />}
                    {/* <div className="FilterButtonPast flex gap-10" >
                        <Button name={'Filters'} src={'/assets/img/Filter list.png'} className={'filterbtn'} />
                    </div> */}
                </div>
                <div className='AdEventcardcontain'>
                    {totalEvents?.length > 0 ? totalEvents?.map((item, index) => (
                        <Eventcard key={index} alt={'Finance Accounting Test'} cardimg={item?.bannerImg ? item?.bannerImg : "/assets/img/eventcard/one.png"} type={'FINANCE'} heading={item?.title ? item?.title : "---"}
                        countreg={item?.registrationCount ? item?.registrationCount : 0} time={item?.fromTime ? moment(item?.fromTime).format("h:mm a") : "---"} date={item?.fromDate ? moment(item?.fromDate).format("DD MMMM, YYYY") : "---"} contact={item?.zoomLink ? item?.zoomLink : "https://www.zoom.us"} onClick={() => navigate(`/admin/event-details/${item?.id}`)}
                        />
                        )) : !isEventsFetching && <DatanotFound />}
                        {isEventsFetching &&
                    <>
                    {[1,2,3].map(item => (
                        <div className='eventcardbox' key={item}>
                        <div className="eventcardbanner">
                            <Skeleton width={"350px"} height={"200px"} />
                        </div>
            
                        <div className="Adcardeventboxtext">
                            <div className="">
                                <Skeleton width={"50px"} />
                            </div>
            
                            <h3 className='texth3event'>{<Skeleton width={"200px"}  />}</h3>
            
                            <div className="regevetCardAd">
                                <h4 className='text3 mb4'><Skeleton width={"100px"} /></h4>
                                <p>{<Skeleton width={"70px"} />}</p>
                            </div>
            
                            <div className="timeAdevetcard flex gap-10">
                                <div className="borderevent"></div>
                                <span className='text3'>{""}</span>
                            </div>
            
                            <div className="EventcardfooterAd flex">
                                <div className="calEventleftAd flex">
                                    {/* <img src="/assets/img/calendarblue.png" alt="" /> */}
                                    <span className='text2'>{<Skeleton width={"100px"} />}</span>
                                </div>
            
                                <div className='zoombtn'>{<Skeleton width={'50px'} />}</div>
                            </div>
                        </div>
            
                    </div>
                    ))}
                    </>}
                </div>
            {(!isEventsFetching && (totalEvents?.length < events?.totalCount)) && <div className="lodeemorebutton mt10" ref={targetRef}>
                        <Button name={'Load More'} className={'BlueFillButton buttontext'} onClick={handleLoadMore} />
                    </div>}
            </div>
        </div>
                        </>
    )
}

export default Events